<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="[data.componentBaseClassName, data.componentClassName]">
    <div
      v-if="regionsHtml.title"
      :class="data.titleClassName"
      v-html="regionsHtml.title"
    />
    <div v-if="products.length" :class="data.productsClassName">
      <BaseLink
        v-for="(product, index) in products"
        :key="`${data.productsClassName}-product-${index}`"
        :class="data.imageClassName"
        :url="product.link"
      >
        <BaseImage
          :src="product.image"
          :alt="product.name"
          @load="handleImageLoad(product, index)"
          @image-click="emitAnalyticsData(product, index)"
        />
      </BaseLink>
    </div>
  </div>
</template>

<script>
import BaseImage from './BaseImage.vue';
import BaseLink from './BaseLink.vue';
import bemClassesMixin from '../mixins/bemClassesMixin';
import EventBusConfig from '../config/eventBusConfig';
import pageDesignerMixin from '../mixins/pageDesignerMixin';

export default {
  name: 'ThePageComponentRecommendedProducts',

  components: {
    BaseImage,
    BaseLink,
  },

  mixins: [bemClassesMixin, pageDesignerMixin],

  props: {
    isRecommendationFromEinstein: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      products: [],
    };
  },

  created() {
    if (this.data?.maxProductsToShow && this.data?.urlGetProducts) {
      // generar placeholders
      for (let i = 0; i < this.data?.maxProductsToShow; i++) {
        this.products.push({
          name: '',
          image: null,
          link: null,
          pid: null,
        });
      }
    } else if (this.data?.products?.products) {
      this.products = this.data.products.products;
    }
  },

  mounted() {
    this.setProductsInfo();
  },

  methods: {
    handleImageLoad(product, index) {
      this.emitAnalyticsData(
        product,
        index,
        EventBusConfig.events.TheSearchModal.recommendedProductViewed
      );
    },
    setProductsInfo() {
      if (!this.data?.urlGetProducts) return;
      fetch(this.data.urlGetProducts)
        .then((res) => res.json())
        .then(({ recommendations = [] }) => {
          this.products = recommendations?.map(({ product }) => product) || [];
        });
    },
    emitAnalyticsData(product, index, eventName = null) {
      if (!product?.pid) return;
      this.$eventBus.$emit(
        eventName ||
          EventBusConfig.events.TheSearchModal.recommendedProductClicked,
        {
          product,
          index,
          componentType: this.data.componentType,
          recommender: {
            name: this.data.recommenderName,
            isEinstein: this.isRecommendationFromEinstein,
          },
        }
      );
    },
  },
};
</script>
